import React, { forwardRef, useEffect, useRef, useState } from 'react'

import "../css/NewImageSlider.css"
import * as imagesdata from '../imagesdata'

import { gsap } from 'gsap';

const preloadImages = (selector) => {
    return new Promise((resolve) => {
        const images = document.querySelectorAll(selector);
        let loadedCount = 0;
        const totalImages = images.length;

        images.forEach(img => {
            const imgElement = new Image();
            imgElement.src = img.src;
            imgElement.onload = () => {
                loadedCount++;
                if (loadedCount === totalImages) {
                    resolve();
                }
            };
        });
    });
};

const Slide = forwardRef(({ slide, isCurrent }, ref) => {
    const [width, setWidth] = useState(window.innerWidth)
    useEffect(() => {

        const handleResize = () => {
            setWidth(window.innerWidth)
        }
        window.addEventListener('resize', handleResize);
        handleResize();

        return () => window.removeEventListener('resize', handleResize);
    }, [])
    return (
        <figure ref={ref} className="slide">
            <div className="slide__img-wrap">
                <div className="slide__img" style={{ backgroundImage: `url(${slide.img})` }}></div>
            </div>
            <figcaption className="slide__caption">
                <h2 className="slides__caption-headline">
                    <span className="text-row"><span>{slide.headline}</span></span>
                </h2>
                <a className="slides__caption-link" href="#"><span>Explore</span></a>
            </figcaption>
        </figure>
    );
});




const NewImageSlider = () => {

    const [loading, setLoading] = useState(true);
    const [currentSlide, setCurrentSlide] = useState(0);
    const [isAnimating, setIsAnimating] = useState(false)
    const [pageWidth, setPageWidth] = useState(window.innerWidth)
    const slidesRef = useRef([]);
    const indicatorRef = useRef(null);
    const intervalRef = useRef(null);
    const currentSlideRef = useRef(currentSlide);
    const interval = 10000; // 5 saniye

    const startX = useRef(0);
    const deltaX = useRef(0);

    const slides = [
        {
            id: 1, img: imagesdata.ImageSlider1, headline: 'Trafiği Anlık İzle',
            description: 'Klasik tasarım kapılar ile evinizde zamansız bir zarafet yaratın.',
            src: '/trafik-akisi'
        },
        {
            id: 2, img: imagesdata.ImageSlider2, headline: 'Yoldaki Araçları Gör',
            description: 'Evinizin modern dokusunu tamamlayan şık ve dayanıklı kapılar.',
            src: '/trafik-akisi'
        },
        {
            id: 3, img: imagesdata.ImageSlider3, headline: 'Trafik Yoğunluğunu Keşfet',
            description: 'Yüksek güvenlik standartlarına sahip kapılar ile evinizi koruyun.',
            src: '/trafik-akisi'
        },
        {
            id: 4, img: imagesdata.ImageSlider4, headline: 'Akıllı Yol Verileri',
            description: 'Doğal ahşap kapılar ile evinize sıcaklık ve doğallık katın.',
            src: '/trafik-akisi'
        }
    ];

    const totalSlides = slides.length;
    const indicatorHeight = 180;
    const indicatorIncrement = indicatorHeight / totalSlides;


    const config = {
        clipPath: {
            initial: 'polygon(0% 0%, 100% 0%, 100% 100%, 0% 100%)',
            final: pageWidth < 1200 ? 'polygon(50% 10%, 70% 50%, 50% 90%, 30% 50%)' : 'polygon(50% 10%, 60% 50%, 50% 90%, 40% 50%)',
            hover: pageWidth < 1200 ? 'polygon(50% 10%, 70% 50%, 50% 90%, 30% 50%)' : 'polygon(50% 10%, 60% 50%, 50% 90%, 40% 50%)'
        }
    };

    useEffect(() => {
        preloadImages('.slide__img').then(() => {
            setLoading(false);
        });
    }, []);

    const [sliderHeight, setSliderHeight] = useState(window.innerHeight <= 700 ? 700 : window.innerHeight)

    useEffect(() => {
        if(window.innerHeight <= 700) {
            setSliderHeight(700)
        }
        else {
            setSliderHeight(window.innerHeight)
        }
    })
    useEffect(() => {

        const handleResize = () => {
            let width = window.innerWidth
            setPageWidth(width)
        }
        window.addEventListener('resize', handleResize);
        handleResize();

        return () => window.removeEventListener('resize', handleResize);
    }, [])



    const startInterval = () => {
        if (!intervalRef.current) {
            intervalRef.current = setInterval(() => {
                navigate('next');
            }, interval); // 3 saniyede bir sonraki slayta geç
        }
    };

    const stopInterval = () => {
        if (intervalRef.current) {
            clearInterval(intervalRef.current);
            intervalRef.current = null;
        }
    };

    // Sayfa görünürlüğü değiştiğinde interval'i yönet
    const handleVisibilityChange = () => {
        if (document.visibilityState === 'visible') {
            startInterval(); // Sayfa görünürse interval'i başlat
        } else {
            stopInterval(); // Sayfa gizlenirse interval'i durdur
        }
    };

    useEffect(() => {
        // İlk render'da interval başlat
        startInterval();

        // Visibility değişim olayını dinle
        document.addEventListener('visibilitychange', handleVisibilityChange);

        // Cleanup: Sayfa unmount olduğunda interval'i ve event listener'ı temizle
        return () => {
            stopInterval();
            document.removeEventListener('visibilitychange', handleVisibilityChange);
        };
    }, []);

    const handleArrowClick = (direction) => {
        stopInterval();
        navigate(direction);
        startInterval();
    };


    const navigate = (direction) => {
        if (isAnimating) {
            return false
        }
        setIsAnimating(true)
        setCurrentSlide(prevSlide => {
            let newCurrent = prevSlide;

            if (direction === 'next') {
                newCurrent = prevSlide < slidesRef.current.length - 1 ? prevSlide + 1 : 0;
            } else {
                newCurrent = prevSlide > 0 ? prevSlide - 1 : slidesRef.current.length - 1;
            }

            const currentSlide1 = slidesRef.current[prevSlide];
            const upcomingSlide = slidesRef.current[newCurrent];


            const newIndicatorHeight = (newCurrent + 1) * indicatorIncrement;

            gsap.to(indicatorRef.current, {
                height: `${newIndicatorHeight}px`,
                duration: 1,
                ease: 'power3.inOut',
            });


            gsap.timeline({
                onStart: () => {
                    upcomingSlide.classList.add('slide--current');
                },
                onComplete: () => {
                    currentSlide1.classList.remove('slide--current');
                    setIsAnimating(false)
                }
            })
                .addLabel('start', 0)
                .set(upcomingSlide.querySelector('.slide__img-wrap'), {
                    x: direction === 'next' ? '100%' : '-100%',
                    y: direction === 'next' ? '-100%' : '100%',
                    clipPath: config.clipPath.final
                }, 'start')
                .set(upcomingSlide, { opacity: 1 }, 'start')
                .set(upcomingSlide.querySelector('.slide__img'), {
                    x: direction === 'next' ? '-100%' : '100%',
                    y: direction === 'next' ? '100%' : '-100%'
                }, 'start')
                .set(upcomingSlide.querySelector('.text-row > span'), { y: direction === 'next' ? '100%' : '-100%', stagger: 0.05 }, 'start')
                .set(upcomingSlide.querySelector('.slides__caption-link'), { opacity: 0, display: "none" }, 'start')
                .to(currentSlide1.querySelector('.slide__img-wrap'), {
                    duration: 1,
                    ease: 'expo',
                    clipPath: config.clipPath.final,
                    rotation: 0.001
                }, 'start')
                .to(currentSlide1.querySelector('.text-row > span'), {
                    duration: 0.7,
                    ease: 'power3',
                    y: direction === 'next' ? '-100%' : '100%',
                    stagger: 0.05,
                }, 'start')
                .to(currentSlide1.querySelector('.slides__caption-link'), {
                    duration: 0.5,
                    ease: 'power3',
                    opacity: 0,
                    display: "none"
                }, 'start')
                .to(currentSlide1.querySelector('.slide__img-wrap'), {
                    duration: 0.7,
                    ease: 'expo.inOut',
                    x: direction === 'next' ? '-100%' : '100%',
                    y: direction === 'next' ? '100%' : '-100%',
                    rotation: 0.001
                }, 'start+=0.4')
                .to(currentSlide1.querySelector('.slide__img'), {
                    duration: 0.7,
                    ease: 'expo.inOut',
                    x: direction === 'next' ? '100%' : '-100%',
                    y: direction === 'next' ? '-100%' : '100%'
                }, 'start+=0.4')
                .to(upcomingSlide.querySelector('.slide__img-wrap'), {
                    duration: 0.7,
                    ease: 'expo',
                    x: '0%',
                    y: '0%',
                    rotation: 0.001
                }, 'start+=0.7')
                .to(upcomingSlide.querySelector('.slide__img'), {
                    duration: 0.7,
                    ease: 'expo',
                    x: '0%',
                    y: '0%'
                }, 'start+=0.7')
                .to(upcomingSlide.querySelector('.slide__img-wrap'), {
                    duration: 1,
                    ease: 'expo.inOut',
                    clipPath: config.clipPath.initial
                }, 'start+=0.9')
                .to(upcomingSlide.querySelector('.text-row > span'), {
                    duration: 0.7,
                    ease: 'power3.inOut',
                    rotation: 0.001,
                    y: '0%',
                    stagger: direction === 'next' ? 0.1 : -0.1
                }, 'start+=1')
                .to(upcomingSlide.querySelector('.slides__caption-link'), {
                    duration: 0.2,
                    ease: 'power3.in',
                    opacity: 1,
                    display: "inline-block"
                }, 'start+=1.3')

                return newCurrent;
        })

    };

    useEffect(() => {
        const currentEl = slidesRef.current[currentSlide];
        const previousEl = slidesRef.current[(currentSlide === 0 ? slides.length : currentSlide) - 1];
        const initialHeight = (currentSlide + 1) * indicatorIncrement;
        if (currentEl && previousEl) {
            gsap.set(slidesRef.current[currentSlide].querySelector('.slide__img-wrap'), { clipPath: config.clipPath.initial });
            gsap.to(indicatorRef.current, { height: `${initialHeight}px`, duration: 1, ease: "power3.inOut" });
            slidesRef.current.forEach((slide, index) => {
                const imgWrap = slide.querySelector('.slide__img-wrap');
                const link = slide.querySelector('.slides__caption-link');

                const mouseEnterHandler = () => {
                    gsap.killTweensOf(imgWrap);
                    gsap.to(imgWrap, {
                        duration: 0.7,
                        ease: 'expo',
                        clipPath: config.clipPath.hover
                    });
                };

                const mouseLeaveHandler = () => {
                    gsap.killTweensOf(imgWrap);
                    gsap.to(imgWrap, {
                        duration: 0.7,
                        ease: 'expo',
                        clipPath: config.clipPath.initial
                    });
                };

                link.addEventListener('mouseenter', mouseEnterHandler);
                link.addEventListener('mouseleave', mouseLeaveHandler);
            });
            return () => {
                slidesRef.current.forEach((slide, index) => {
                    const link = slide.querySelector('.slides__caption-link');
                    link.removeEventListener('mouseenter', () => { });
                    link.removeEventListener('mouseleave', () => { });
                });
            };
        }
    }, [currentSlide, config.clipPath, indicatorIncrement]);

    const handleStart = (event) => {
        const startXPosition = event.type === 'mousedown' ? event.clientX : event.touches[0].clientX;
        startX.current = startXPosition;

    };

    const handleMove = (event) => {
        if (startX.current !== 0) {
            const currentX = event.type === 'mousemove' ? event.clientX : event.touches[0].clientX;
            deltaX.current = currentX - startX.current;
        }
    };

    const handleEnd = () => {
        if (Math.abs(deltaX.current) > 100) { // Belirli bir mesafeye ulaşıldığında
            const direction = deltaX.current > 0 ? 'prev' : 'next';
            handleArrowClick(direction);
        }

        // Değerleri sıfırla
        startX.current = 0;
        deltaX.current = 0;
    };

    return (
        <div className={loading ? 'loading' : ''}>
            <div class="image-slider-main"
                onMouseDown={handleStart}
                onTouchStart={handleStart}
                onMouseMove={handleMove}
                onTouchMove={handleMove}
                onMouseUp={handleEnd}
                onTouchEnd={handleEnd}
                onMouseLeave={handleEnd}>
                <div className="image-slider-slideshow" style={{ height: `${sliderHeight}px` }}>
                    <figure ref={el => slidesRef.current[0] = el} className="slide slide--current">
                        <div className="slide__img-wrap">
                            <div className="slide__img" style={{ backgroundImage: `url(${slides[0].img})` }}></div>
                        </div>
                        <figcaption className="slide__caption">
                            <h2 className="slides__caption-headline" style={{ maxWidth: `${(pageWidth * 70) / 100}px` }}>
                                <span className="text-row"><span>{slides[0].headline}</span></span>
                            </h2>
                            <div className='slides__caption-link-div'>
                                <a className="slides__caption-link" href={slides[0].src}><span>Detayları Keşfedin</span></a>
                            </div>
                        </figcaption>
                    </figure>

                    <figure ref={el => slidesRef.current[1] = el} className="slide">
                        <div className="slide__img-wrap">
                            <div className="slide__img" style={{ backgroundImage: `url(${slides[1].img})` }}></div>
                        </div>
                        <figcaption className="slide__caption">
                            <h2 className="slides__caption-headline" style={{ maxWidth: `${(pageWidth * 70) / 100}px` }}>
                                <span className="text-row"><span>{slides[1].headline}</span></span>
                            </h2>
                            <div className='slides__caption-link-div'>
                                <a className="slides__caption-link" href={slides[1].src}><span>Detayları Keşfedin</span></a>
                            </div>
                        </figcaption>
                    </figure>

                    <figure ref={el => slidesRef.current[2] = el} className="slide">
                        <div className="slide__img-wrap">
                            <div className="slide__img" style={{ backgroundImage: `url(${slides[2].img})` }}></div>
                        </div>
                        <figcaption className="slide__caption">
                            <h2 className="slides__caption-headline" style={{ maxWidth: `${(pageWidth * 70) / 100}px` }}>
                                <span className="text-row"><span>{slides[2].headline}</span></span>
                            </h2>
                            <div className='slides__caption-link-div'>
                                <a className="slides__caption-link" href={slides[2].src}><span>Detayları Keşfedin</span></a>
                            </div>
                        </figcaption>
                    </figure>

                    <figure ref={el => slidesRef.current[3] = el} className="slide">
                        <div className="slide__img-wrap">
                            <div className="slide__img" style={{ backgroundImage: `url(${slides[3].img})` }}></div>
                        </div>
                        <figcaption className="slide__caption">
                            <h2 className="slides__caption-headline" style={{ maxWidth: `${(pageWidth * 70) / 100}px` }}>
                                <span className="text-row"><span>{slides[3].headline}</span></span>
                            </h2>
                            <div className='slides__caption-link-div'>
                                <a className="slides__caption-link" href={slides[3].src}><span>Detayları Keşfedin</span></a>
                            </div>

                        </figcaption>
                    </figure>
                </div>

                <div className="slides__caption-indicator">
                    <div ref={indicatorRef} className="slides__caption-indicator-before"></div>
                    <div className='slides__caption-indicator-current-number'><span > 0{currentSlide + 1} </span></div>
                    <div className='slides__caption-indicator-total-number'>0{totalSlides}</div>
                </div>

                <div className="slides__caption-arrow">
                    <nav className='image-slider-slides-nav'>
                        <button className="image-slider-slides-nav__button image-slider-slides-nav__button--prev" onClick={() => handleArrowClick('prev')} aria-label="Previous slide">
                            <svg><path d="M1.176 11.532a.5.5 0 00-.352.936c5.228 1.96 9.475 5.555 12.752 10.797a.5.5 0 00.848-.53c-3.39-5.424-7.81-9.163-13.248-11.203z" /><path d="M1.176 12.468a.5.5 0 01-.352-.936C6.052 9.572 10.3 5.978 13.576.735a.5.5 0 01.848.53c-3.39 5.424-7.81 9.163-13.248 11.203z" /><path d="M1 12.5a.5.5 0 110-1h53a.5.5 0 110 1H1z" /></svg>
                        </button>
                        <button className="image-slider-slides-nav__button image-slider-slides-nav__button--next" onClick={() => handleArrowClick('next')} aria-label="Next slide">
                            <svg><path d="M53.824 11.532a.5.5 0 01.352.936c-5.228 1.96-9.475 5.555-12.752 10.797a.5.5 0 01-.848-.53c3.39-5.424 7.81-9.163 13.248-11.203z" /><path d="M53.824 12.468a.5.5 0 00.352-.936C48.948 9.572 44.7 5.978 41.424.735a.5.5 0 00-.848.53c3.39 5.424 7.81 9.163 13.248 11.203z" /><path d="M54 12.5a.5.5 0 100-1H1a.5.5 0 100 1h53z" /></svg>
                        </button>
                    </nav>
                </div>
            </div >
        </div>
    )
}

export default NewImageSlider